module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_04-e39db43b226d0163f980fb04d1fe3802.jpg";